import React, { useState, useEffect } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { Input } from "../../../../../common/Input";
import { ConfirmationModal } from "../../../../../common/Modal";

const OperationBenefitGroupModal = ({ mode, isOpen, onClose, selectedItem, onSave }) => {
  const [form, setForm] = useState({ description: "" });
  const [errors, setErrors] = useState({});
  const [showConfirmModal, setShowConfirmModal] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setForm(selectedItem || { description: "" });
      setErrors({});
      setShowConfirmModal(false);
    }
  }, [isOpen, selectedItem]);

  const handleSaveClick = () => {
    if (!form.description?.trim()) {
      return setErrors({ description: "Description is required" });
    }
    setShowConfirmModal(true);
  };

  const handleConfirmSave = () => {
    setShowConfirmModal(false);
    onSave(form);
  };

  if (!isOpen) return null;

  return (
    <>
      <div className="fixed inset-0 z-[10000] bg-black/50 flex items-center justify-center p-4">
        <div className="bg-white w-full max-w-xl rounded-lg shadow-2xl flex flex-col max-h-[90vh]">

          {/* Header */}
          <div className="px-6 py-4 border-b flex justify-between items-center rounded-t-lg bg-gray-100/50">
            <div>
              <h2 className="text-xl font-bold">{mode} Benefit Group</h2>
            </div>
            <button onClick={onClose} className="p-2 rounded-full hover:bg-gray-200 transition-colors border-none bg-transparent cursor-pointer">
              <CloseIcon className="text-gray-500" />
            </button>
          </div>

          <div className="p-6 space-y-4">
            <Input
              label="Group Name"
              placeholder="e.g., Sea Pay, Risk Allowance"
              value={form.description}
              onChange={(e) => setForm({ ...form, description: e.target.value })}
              error={!!errors.description}
              errorMessage={errors.description}
            />
          </div>

          <div className="p-4 border-t flex justify-end gap-2 bg-gray-50 rounded-b-lg">
            <button onClick={onClose} className="px-4 py-2 border rounded bg-white text-gray-500 font-bold cursor-pointer">CANCEL</button>
            <button onClick={handleSaveClick} className="px-6 py-2 bg-customGreen text-white rounded border-none font-bold cursor-pointer">SAVE CATEGORY</button>
          </div>
        </div>
      </div>

      <ConfirmationModal
        visible={showConfirmModal}
        onClose={() => setShowConfirmModal(false)}
        onConfirm={handleConfirmSave}
        title="Confirm Benefit Group"
        message={`Are you sure you want to ${mode?.toLowerCase() === "edit" ? "update" : "create"} the benefit group "${form.description}"?`}
        confirmText="Yes, Save"
        cancelText="Cancel"
        type="info"
      />
    </>
  );
};

export default OperationBenefitGroupModal;